import { Component, OnInit, ViewChild } from "@angular/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { RoyalDecreeService } from "../../core/services/royal-decree.service";
import { CommonService } from "src/app/core/services/common.service";
import { FilterConstants } from "src/app/constants/filterConstants";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { Router } from "@angular/router";
import { forEach } from "@angular-devkit/schematics";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-list-available-fields",
  templateUrl: "./list-available-fields.component.html",
  styleUrls: ["./list-available-fields.component.sass"],
})
export class ListAvailableFieldsComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  showTableFilter: boolean = false;
  showFilterButtons: boolean = false;
  public filtersTable: string;
  filtersTableJSON;
  public filtersSearch = "";
  filterList = FilterConstants.availableFieldsRoyalDecree;
  tableList = TableConstants.royalDecree;
  routing = RoutingConstants.royalDecreeRouting;
  options = TableConstants.NotShowArrowUpDown;
  listAvailableFields;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  constructor(
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private royalDecreeService: RoyalDecreeService,
    private commonService: CommonService,
    private router: Router
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admSistemas.availableFields
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
  }

  ngOnInit(): void {
    this.loadAvailableFields();
  }

  loadAvailableFields() {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.royalDecreeService.listFieldsAvailable(filters).subscribe(
      (data) => {
        data["content"].forEach(function (element) {
          if (
            element.cdTipo == "DBLIST" ||
            element.cdTipo == "BOOL" ||
            element.cdTipo == "LIST" ||
            element.cdTipo == "FILE" ||
            element.cdTipo == "LITERAL"
          ) {
            element.cdLongitud = null;
          }
        });
        this.listAvailableFields = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        if (data["content"] && data["content"].length == 0) {
          this.toastrAlertService.toastrWarning(
            "No hay ningun campo disponible para esta busqueda"
          );
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadAvailableFields();
  }

  filterSearch(value: string) {
    this.filtersSearch = value;
    this.filtersTableStateService.setPageState(0);
    this.filtersTableJSON =
      this.filtersTableStateService.getFiltersTableState();
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.loadAvailableFields();
  }

  removeElements(ids: string[]) {
    this.royalDecreeService.removeFieldsAvailable(ids).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data["mensaje"]);
        this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
          this.routing.id,
          ScreenConstants.admSistemas.availableFields
        );
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadAvailableFields();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();

        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadAvailableFields();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  goSpecificFields() {
    this.router.navigate([this.routing.tree]);
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
